import { render } from "./Cta.vue?vue&type=template&id=bfdbb77e&scoped=true"
import script from "./Cta.vue?vue&type=script&lang=js"
export * from "./Cta.vue?vue&type=script&lang=js"

import "./Cta.vue?vue&type=style&index=0&id=bfdbb77e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfdbb77e"]])

export default __exports__